import { DateTime, Duration } from 'luxon';

export const daysInISOduration = (d: string): number =>
  Duration.fromISO(d).shiftTo('days').days;

export enum DataProtectionDifference {
  SAME = 'SAME',
  GROUP_SHORTER = 'GROUP_SHORTER',
  GROUP_LONGER = 'GROUP_LONGER',
  INVALID = 'INVALID',
}

export const getDataProtectionDifference = (
  groupPeriod?: string,
  orgPeriod?: string,
) => {
  if (!groupPeriod) return DataProtectionDifference.INVALID;
  if (!orgPeriod) return DataProtectionDifference.INVALID;
  const groupDataProtectionDuration = daysInISOduration(groupPeriod);
  const orgDataProtectionDuration = daysInISOduration(orgPeriod);
  if (groupDataProtectionDuration === orgDataProtectionDuration) {
    return DataProtectionDifference.SAME;
  }
  if (groupDataProtectionDuration > orgDataProtectionDuration) {
    return DataProtectionDifference.GROUP_LONGER;
  }
  return DataProtectionDifference.GROUP_SHORTER;
};

export const convertEtcTimezoneToUtc = (zone?: string): string => {
  const timezone = zone?.replace('GMT', 'UTC') || 'UTC';
  const match = timezone.match(/^Etc\/UTC([+-]\d{1,2})$/);
  if (!match) return timezone;
  const invertedHours = -Number(match[1]);
  const sign = invertedHours >= 0 ? '+' : '-';
  const formattedHours = Math.abs(invertedHours).toString().padStart(2, '0');
  return `UTC${sign}${formattedHours}:00`;
};

export const toShareIsoFormatFromDateTime = (datetime: DateTime) =>
  datetime.toISO({
    suppressMilliseconds: true,
  }) as string;

export const toDownloadRangeFormatFromDateTime = (date?: DateTime): string => {
  if (!date?.isValid) {
    throw new Error('Invalid DateTime provided');
  }
  const isoDate = date.toUTC().toISODate();
  if (isoDate === null) {
    throw new Error('Failed to format DateTime to ISO string');
  }
  return isoDate;
};

// Computed at module load time to provide a stable React Query key.
export const stableNowForAPI = DateTime.fromISO(DateTime.local().toString(), {
  zone: 'UTC',
}).toString();
